import React from 'react';
import moment from 'moment';
import { Input } from 'reactstrap';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

//assets
import { SimpleSelectWidget } from '~/components/GenericForm/Widgets/SimpleSelect';

const isPastDate = (date) => {
    const currentDate = new Date();
    const holidayDate = new Date(date);
    return currentDate > holidayDate && !moment(date).isSame(moment(), 'day');
};

const HolidayRow = React.memo(({ holiday, onHolidaySelect, onCustomNameChange, onPayrollChange, onCountInChange, payrollOptions, showAdvancedColumns = false, t }) => {
    const isDisabled = isPastDate(holiday.date);
    return (
        <tr>
            <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                {showAdvancedColumns ? (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id={`tooltip-enable-${holiday.id}`}>
                                {t(isDisabled ? 'You cannot enable holidays that have already passed' : 'Enable')}
                            </Tooltip>
                        }
                    >
                        <span>
                            <Input
                                type="checkbox"
                                checked={holiday.isSelected}
                                style={{ transform: 'scale(1.2)' }}
                                onChange={isDisabled ? undefined : (e) => onHolidaySelect(holiday.id, e.target.checked)}
                                disabled={isDisabled}
                            />
                        </span>
                    </OverlayTrigger>
                ) : (
                    <Input
                        type="checkbox"
                        checked={holiday.isSelected}
                        style={{ transform: 'scale(1.2)' }}
                        onChange={isDisabled ? undefined : (e) => onHolidaySelect(holiday.id, e.target.checked)}
                        disabled={isDisabled}
                    />
                )}
            </td>
            <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>{holiday.name}</td>
            <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>{holiday.date}</td>
            <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>{holiday.type}</td>
            <td style={{ verticalAlign: 'middle' }}>
                <Input
                    type="text"
                    value={holiday.custom_name}
                    onChange={isDisabled ? undefined : (e) => onCustomNameChange(holiday.id, e.target.value)}
                    style={{ width: '100%', minWidth: '120px' }}
                    disabled={isDisabled}
                />
            </td>
            {showAdvancedColumns && (
                <>
                    <td style={{ verticalAlign: 'middle' }}>
                        <SimpleSelectWidget
                            value={holiday.additionalPayment?.code || ''}
                            options={payrollOptions || []}
                            onChange={isDisabled ? undefined : (value) => onPayrollChange(holiday.id, value)}
                            placeholder="Select"
                            styleClasses="managers-widget"
                            disabled={isDisabled}
                        />
                    </td>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <Input
                            type="checkbox"
                            checked={holiday.accountedInVacation}
                            style={{ transform: 'scale(1.2)' }}
                            onChange={
                                isDisabled
                                    ? undefined
                                    : (e) => onCountInChange(holiday.id, e.target.checked, 'accountedInVacation')
                            }
                            disabled={isDisabled}
                        />
                    </td>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <Input
                            type="checkbox"
                            checked={holiday.accountedInAbsence}
                            style={{ transform: 'scale(1.2)' }}
                            onChange={
                                isDisabled
                                    ? undefined
                                    : (e) => onCountInChange(holiday.id, e.target.checked, 'accountedInAbsence')
                            }
                            disabled={isDisabled}
                        />
                    </td>
                </>
            )}
        </tr>
    );
}
);

HolidayRow.displayName = 'HolidayRow';

export default HolidayRow;